var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.077 8.539V4.904c0-.32.093-.609.28-.865a1.59 1.59 0 0 1 .72-.558l4.615-1.73c.18-.065.36-.097.539-.097.18 0 .359.032.538.096l4.616 1.731c.295.116.535.302.721.558.186.256.28.545.279.865V8.54c0 1.795-.513 3.471-1.539 5.03-1.026 1.557-2.404 2.624-4.134 3.2a1.521 1.521 0 0 1-.962 0c-1.73-.576-3.109-1.644-4.135-3.202C3.59 12.01 3.077 10.333 3.077 8.54zm4.615 3.77h3.077c.218 0 .401-.075.549-.222a.741.741 0 0 0 .22-.548V9.23c0-.218-.073-.4-.221-.548a.741.741 0 0 0-.548-.221v-.77c0-.422-.15-.785-.452-1.086a1.478 1.478 0 0 0-1.086-.452c-.423 0-.786.151-1.087.453a1.478 1.478 0 0 0-.452 1.086v.769c-.218 0-.4.074-.548.222a.741.741 0 0 0-.22.547v2.308c0 .218.073.4.22.548a.74.74 0 0 0 .548.221zm.77-3.847v-.77c0-.217.073-.4.221-.548a.741.741 0 0 1 .548-.22c.218 0 .4.073.548.221.148.148.222.33.221.548v.769H8.462z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.f9081f6939065479084897b87881bf9b.svg";
export { ForwardRef as ReactComponent };